<template>
  <el-dialog
    width="920px"
    :title="title"
    :visible.sync="visiable"
    :show-close="false"
    append-to-body
    :close-on-click-modal="false"
    @open="bindGetData"
  >
    <el-table ref="table" border :height="450" :data="labelData">
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :min-width="col.width"
        :show-overflow-tooltip="col.overflow"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div class="c-label-box" :class="scope.a" v-if="col.key === 'labels'">
            <template v-for="item in scope.row[col.key]">
              <el-checkbox :value="item.check" @change="selectItem($event, item)" :disabled="disabled && !item.check" :key="item.id">{{
                item.name
              }}</el-checkbox>
            </template>
          </div>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>

    <template slot="footer">
      <div class="dialog-footer">
        <el-button @click="visiable = false">取消</el-button>
        <el-button type="primary" @click="save">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, set, computed, nextTick } from 'vue'
import { label_data } from '@/data/tencent/ad_target_data'
import { deepCopy } from '@/common/js/utils'

// Constants
const columns = [
  {
    title: '标签类型',
    key: 'name',
    width: 80
  },
  {
    title: '标签',
    key: 'labels',
    width: 400
  }
]

// eslint-disable-next-line
const props = defineProps({
  value: {
    type: Boolean
  },
  max: {
    type: [Number, String]
  }
})

// eslint-disable-next-line
const emit = defineEmits(['input', 'on-select'])

// Template refs
const table = ref(null)

// Reactive data
const labelData = ref([])

// Computed properties
const visiable = computed({
  get() {
    return props.value
  },
  set(val) {
    emit('input', val)
  }
})

const selectItem = (e, item) => {
  set(item, 'check', e)
}

const selectLabels = computed(() => {
  const getConcat = (sum, item) => {
    return sum.concat(item)
  }
  return labelData.value.map((ret) => ret.labels.filter((met) => met.check)).reduce(getConcat, [])
})

const len = computed(() => {
  return selectLabels.value.length
})

const title = computed(() => {
  return `选择标签  ${len.value ? `（已选${len.value}/${props.max}）` : ''}`
})

const disabled = computed(() => {
  return len.value >= Number(props.max)
})

// Methods
const bindGetData = () => {
  labelData.value = []
  nextTick(() => {
    const data = label_data.map((ret) => {
      ret.labels = ret.children
      return ret
    })
    labelData.value = deepCopy(data)
  })
}

const save = () => {
  emit('on-select', selectLabels.value)
  visiable.value = false
}
</script>

<script>
export default {
  name: 'labelModal'
}
</script>
<style lang="scss" scoped>
::v-deep .c-select-label {
  position: relative;

  .el-input {
    font-size: 12px;
  }

  .el-table {
    th.el-table-column--selection {
      position: relative;

      &.is-leaf {
        .cell {
          display: none !important;
        }
      }
    }

    .el-checkbox {
      margin-right: 8px;
    }
  }

  .dialog-footer {
    text-align: right;
  }
}

.c-label-box {
  .el-checkbox {
    margin-right: 12px;
    margin-bottom: 8px;
  }
}
</style>
